<template>
<v-flex xs12>
    <v-layout row wrap>
        <v-flex d-flex xs12 sm6>
            <slot name="finding">
            </slot>    
        </v-flex>

        <v-flex xs12 sm6>  

            <v-layout row wrap>
                <v-flex xs12>
                    <slot name="measures">
                    </slot>                    
                </v-flex>

                <v-flex xs12>
                    <slot name="createmeasure">
                    </slot>   
                </v-flex>  
            </v-layout>  

        </v-flex>
    </v-layout>
</v-flex>
</template>

<script>
export default {};
</script>
